import React, { useState } from "react";
import "../../iqac.css";
import TopNav from "../../../../../Components/TopNav";
import Navbar from "../../../../../Components/Navbar";
import DropdownNav from "../../../../../Components/DropdownNav";
import Footer from "../../../../../Components/Footer";
import Example from "../../../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const VisionMission = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [framework, setFramework] = useState(false);
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="vis-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className="iqac-obj-tit">Vision & Mission</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className="iqac-obj-det">
        <button
          onClick={() => setIsOpen((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Vision
        </button>
        {isOpen && (
          <div className="obj-items">
            <p>
              ✬ To build and ensure a quality culture with conscious, reliable
              and transparent efforts through a combination of self and external
              quality evaluation, promotion and sustenance initiatives.
            </p>
          </div>
        )}

        <button
          onClick={() => setFramework((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Mission
        </button>
        {framework && (
          <div className="obj-items">
            <p>
              ✬ To channelize and systematize the efforts and measures of an
              institution towards academic excellence.
            </p>
            <p>
              ✬ To be the driving force for ushering in quality to remove
              deficiencies and enhance quality.
            </p>
            <p>
              ✬ To encourage departments to establish student Learning-centric
              environment to use ICT tools for teaching and learning process and
              to inculcate value–based education system.
            </p>
            <p>
              ✬ To ensure an effective and transparent operations to achieve
              excellence in Academic, Administrative and Financial activities
              through timely internal and external audit
            </p>
            <p>
              ✬ To facilitate ICT enabled Teaching – Learning – Evaluation
              augmented with increased course options, Learning Resources and
              Infrastructure facilities.
            </p>
            <p>
              ✬ To formalize the feedback from clients, community, employees
              with necessary follow-up action.
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default VisionMission;
